(function () {
  'use strict';

  /**
   * Icon assets.
   */
  const caretIcon = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.5147 10.4431L12.4601 6.51909C12.5255 6.45464 12.5775 6.37796 12.6129 6.29348C12.6484 6.20899 12.6666 6.11838 12.6666 6.02685C12.6666 5.93533 12.6484 5.84471 12.6129 5.76023C12.5775 5.67574 12.5255 5.59906 12.4601 5.53461C12.3293 5.40549 12.1523 5.33301 11.9678 5.33301C11.7833 5.33301 11.6063 5.40549 11.4755 5.53461L7.98399 8.96643L4.52741 5.53461C4.39657 5.40549 4.21958 5.33301 4.0351 5.33301C3.85062 5.33301 3.67364 5.40549 3.5428 5.53461C3.47682 5.59882 3.42433 5.67539 3.38837 5.75989C3.35241 5.84438 3.3337 5.93512 3.33331 6.02685C3.3337 6.11858 3.35241 6.20932 3.38837 6.29382C3.42433 6.37831 3.47682 6.45488 3.5428 6.51909L7.4882 10.4431C7.55359 10.5135 7.63295 10.5697 7.72128 10.6081C7.80962 10.6465 7.90501 10.6663 8.00145 10.6663C8.09788 10.6663 8.19327 10.6465 8.28161 10.6081C8.36994 10.5697 8.44931 10.5135 8.5147 10.4431Z" fill="#6D7D38"/>
</svg>`;
  const addIcon = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28"><rect width="26.75" height="26.75" x=".625" y=".625" stroke="#6D7D38" stroke-width="1.25" rx="13.375"/><path fill="#6D7D38" d="M13.5 8h1.25v12H13.5V8Z"/><path fill="#6D7D38" d="M20 13.25v1.25H8v-1.25h12Z"/></svg>`;
  const checkIcon = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28"><rect width="26.75" height="26.75" x=".625" y=".625" fill="#6d7d38" rx="13.375"/><rect width="26.75" height="26.75" x=".625" y=".625" stroke="#6d7d38" stroke-width="1.25" rx="13.375"/><path fill="#fff" d="m20.485 10 .884.884-8.485 8.485-.884-.884z"/><path fill="#fff" d="m13.768 18.485-.884.884L8 14.707l.884-.884z"/></svg>`;
  const disabledIcon = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28"><rect width="26.75" height="26.75" x=".625" y=".625" stroke="#949494" stroke-width="1.25" rx="13.375"/></svg>`;

  // Radio-style variants used only by subtotal "choose 1 of N" gift options. The green
  // ring is constant for any unselected state (eligible or disabled); selecting an option
  // adds the filled green inner dot.
  const radioOnIcon = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28"><rect width="26.75" height="26.75" x=".625" y=".625" stroke="#6D7D38" stroke-width="1.25" rx="13.375"/><circle cx="14" cy="14" r="6.25" fill="#6D7D38"/></svg>`;

  /**
   * ProductPicker component.
   */
  class ProductPicker extends HTMLElement {
    constructor() {
      super();

      // The custom cart element that owns this element.
      this.parentCart = null;
      // Swiper configuration.
      this.productsPerSlide = 3;
      this.swiper = null;
      this.swiperElement = null;
      this.swiperWrapper = null;
      // Header elements.
      this.titleElement = null;
      this.subtitleElement = null;

      this.initialize = this.initialize.bind(this);
    }

    connectedCallback() {
      this.classList.add('product-picker');

      this.innerHTML = `
      <details>
        <summary>
          <div class="product-picker__title"></div>
          <div class="product-picker__subtitle"></div>
          ${caretIcon}
        </summary>
        <div class="swiper">
          <div class="swiper-wrapper"></div>
          <div class="swiper-pagination"></div>
        </div>
      </details>
    `;

      this.swiperElement = this.querySelector('.swiper');
      this.swiperWrapper = this.querySelector('.swiper-wrapper');
      this.titleElement = this.querySelector('.product-picker__title');
      this.subtitleElement = this.querySelector('.product-picker__subtitle');
      this.details = this.querySelector('details');

      document.addEventListener('cart:get', this.setVariantSelection);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:get', this.setVariantSelection);
    }

    /**
     * Initialize this element and its Swiper component.
     * @param {MiniCart} parentCart - The cart component that owns this line item.
     * @param {Object} defaultSettings - The default settings for this component.
     */
    initialize(parentCart, defaultSettings = {}) {
      this.parentCart = parentCart;
      this.name = defaultSettings.name || 'ProductPicker';

      if (this.swiper) {
        this.swiper.update();
        return;
      }

      let settings;

      try {
        // Ensure that this component stays opened or closed between page visits per user interaction.
        // If no interaction has been recorded then use default settings.
        const previousSettings = JSON.parse(sessionStorage.getItem(this.name));
        if (!previousSettings) {
          throw new Error();
        }
        settings = previousSettings;
      } catch {
        settings = defaultSettings;
      }

      this.details.open = settings.open;

      this.details.addEventListener('toggle', (event) => {
        // Store the latest state for this component, so it persists into the next page visit.
        settings.open = event.target.closest('details').open;
        sessionStorage.setItem(this.name, JSON.stringify(settings));
      });

      if (settings?.footnote) {
        this.details.insertAdjacentHTML('afterend', settings.footnote);
      }

      // Partition products into each Swiper slide in groups of productsPerSlide.
      const productGroups = [
        ...this.querySelectorAll('.product-picker__item'),
      ].reduce(
        (groups, slide) => {
          const lastSubGroup = groups[groups.length - 1];
          if (lastSubGroup.length < this.productsPerSlide) {
            // Keep filling this subgroup.
            lastSubGroup.push(slide);
          } else {
            // Start a new subgroup.
            groups.push([slide]);
          }
          return groups;
        },
        [[]], // Init the first subgroup.
      );

      // Assign each subgroup to its own Swiper slide.
      productGroups.forEach((subgroup) => {
        const swiperSlide = document.createElement('div');
        swiperSlide.classList.add('swiper-slide');
        subgroup.forEach((productSlide) =>
          swiperSlide.appendChild(productSlide),
        );
        this.swiperWrapper.appendChild(swiperSlide);
      });

      this.swiper = new window.Swiper(this.swiperElement, {
        autoHeight: true,
        observer: true,
        observeParents: true,
        keyboard: {
          enabled: true,
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    }

    /**
     * Add a pickable product to this element. Renders as its own Swiper slide.
     * @param {string|number} id - The item's variant id or some other unique identifier.
     * @param {string} title - The main title of this variant.
     * @param {string} subtitle - The subtitle for this variant.
     * @param {string} image - The image URL for this variant.
     * @param {Object[]} variants - An array of variant objects that the user may select.
     *
     * @returns {HTMLElement} The pickable product element that was added to Swiper.
     */
    addProduct(id, title, subtitle, image, variants) {
      const pickableProduct = document.createElement('div');
      pickableProduct.classList.add('product-picker__item');
      pickableProduct.setAttribute('data-id', id.toString());
      pickableProduct.setAttribute('data-selected', 'false');
      pickableProduct.setAttribute('data-disabled', 'false');

      pickableProduct.innerHTML = `
      <div class="product-picker__item__wrapper">
        ${image ? `<img src="${image}" width="56" height="56" alt="" loading="lazy"/>` : ''}
        <div>
          <div class="product-picker__item__title">
            ${title}
          </div>
          <div class="product-picker__item__subtitle">
            ${subtitle}
          </div>
          ${this.displayVariantOptions(variants)}
        </div>
        <button aria-label="${window.locales.cart.toggle_product}">
          <span class="product-picker__icon product-picker__icon--disabled">
            ${disabledIcon}
          </span>
          <span class="product-picker__icon product-picker__icon--add">
            ${addIcon}
          </span>
          <span class="product-picker__icon product-picker__icon--check">
            ${checkIcon}
          </span>
        </button>
      </div>
    `;

      this.swiperWrapper.insertAdjacentElement('beforeend', pickableProduct);
      return pickableProduct;
    }

    /**
     * Set this element's main title text.
     * @param {string} text
     */
    setTitleText(text) {
      this.titleElement.innerText = text;
    }

    /**
     * Set this element's main detail text.
     * @param {string} text
     */
    setDetailText(text) {
      this.subtitleElement.innerText = text;
    }

    displayVariantOptions(variants) {
      if (!variants || variants.length < 2) {
        return '';
      }

      const radios = variants
        .map((v, index) => {
          return `
          <input
            class="visually-hidden"
            type="radio"
            id="${v.uuid}"
            name="variant-option"
            value="${v.giftVariantId}"
            data-promo-index="${index}"
            ${v.available ? '' : 'disabled'}
          >
          <label for="${v.uuid}">
            <img src="${v.image}&width=60" alt="${v.title}" loading="lazy" width="30" height="30">
          </label>
        `;
        })
        .join('');

      return `
      <div class="product-picker__variant-options">
        ${radios}
      </div>
    `;
    }

    /**
     *  Whenever the cart gets updated the selected variant for any gift product is automatically selected.
     *  @param {object} event.detail The payload of the custom event, which contains the updated cart data.
     */
    setVariantSelection({ detail: cart }) {
      cart.items
        .filter((item) => item.properties?._promo_id)
        .forEach((item) => {
          // Find and "check" the variant that belongs to this promo component.
          const allVariantRadios = this.querySelectorAll(
            `.product-picker__item[data-id="${item.properties._promo_id}"] input[name="variant-option"]`,
          );
          allVariantRadios.forEach((radio) => {
            radio.checked = radio.value === String(item.variant_id);
          });
        });
    }

    /**
     * Clears any selected variant for the specified promo.
     * @param {*} promo
     */
    clearVariantSelection(promo) {
      [
        ...this.querySelectorAll(
          `.product-picker__item[data-id="${promo.id}"] input[name="variant-option"]`,
        ),
      ].forEach((radio) => {
        radio.checked = false;
      });
    }
  }

  customElements.define('product-picker', ProductPicker);

  /**
   * BundledItems component.
   */
  class BundledItems extends HTMLElement {
    /**
     * Initializes this element with the provided Shopify line items.
     * @param {Array} items - Array of Shopify line item objects.
     */
    initialize(items) {
      const itemListDetails = items.map(
        (item) => `
      <div class="bundled-items__content__item">
        <img
          src="${item.featured_image.url}&width=160"
          alt="${item.featured_image.alt}"
          width="40"
          height="40"
          loading="lazy"/>
        <div>
          ${item.product_title.replace('(bundle item)', '')}
          <br/>
          x${item.properties._bundle_quantity_multiplier || item.quantity}
        </div>
      </div>
    `,
      );

      this.innerHTML = `
      <details>
        <summary>
          ${window.locales.cart.included_bundled_items}
          ${caretIcon}
        </summary>
        <div class="bundled-items__content">
          ${itemListDetails.join('')}
        </div>
      </details>
    `;
    }
  }
  customElements.define('bundled-items', BundledItems);

  /**
   * SellingPlanPicker component.
   */
  class SellingPlanPicker extends HTMLElement {
    constructor() {
      super();

      this.parentCart = null; // The cart component that owns this line item.
      this.key = null; // This line item's key.
      this.quantity = null; // This line item's quantity.
      this.sellingPlans = []; // All selling plans available for this line item.
      this.activeSellingPlan = null; // This line item's current plan, if any
      this.childrenSellingPlans = []; // A simple list of selling plans for children items, if any.

      // Event handlers.
      this.handleSellingPlanToggle = this.handleSellingPlanToggle.bind(this);
      this.handleSellingPlanChange = this.handleSellingPlanChange.bind(this);
    }

    /**
     * Initialize this component by fetching this item's product data. Only items with
     * selling plans will be rendered. Fetched results are saved in local storage.
     * @param {Object} item - The line item data object from the cart.
     * @param {MiniCart} parentCart - The cart component that owns this line item.
     * @param {Object[]} childrenItems - Additional line items that belong to `item` (parent) as a bundle.
     */
    initialize(item, parentCart, childrenItems = []) {
      this.parentCart = parentCart;
      this.key = item.key;
      this.quantity = item.quantity;

      if (item.selling_plan_allocation) {
        this.activeSellingPlan = item.selling_plan_allocation.selling_plan;
      }

      if (childrenItems.length && this.activeSellingPlan) {
        this.childrenSellingPlans = childrenItems.reduce((plans, child) => {
          plans.push({
            key: child.key,
            sellingPlans: child.properties._selling_plans
              .split(',')
              .map(Number),
            quantity: child.quantity,
          });
          return plans;
        }, []);
      }

      const storageKey = `${item.handle}-selling-plans`;
      const cachedData = sessionStorage.getItem(storageKey);

      if (cachedData) {
        this.sellingPlans = JSON.parse(cachedData);
        this.render();
        return;
      }

      // Fetch the latest product data to discover any allocated selling plans.
      fetch(`/products/${item.handle}.js`)
        .then((response) => response.json())
        .then((data) => {
          // Initialize as having no selling plans.
          sessionStorage.setItem(storageKey, '[]');

          if (!data.selling_plan_groups.length) {
            return;
          }

          this.sellingPlans = data.selling_plan_groups.reduce(
            (plans, group) => plans.concat(group.selling_plans),
            [],
          );

          if (!this.sellingPlans.length) {
            return;
          }

          sessionStorage.setItem(storageKey, JSON.stringify(this.sellingPlans));
          this.render();
        });
    }

    /**
     * Render the actual component, allowing the user to toggle and select a selling plan.
     */
    render() {
      if (!this.sellingPlans.length) {
        this.remove();
        return;
      }

      const labelText = this.activeSellingPlan
        ? window.locales.cart.subscribed
        : window.locales.cart.subscribe_and_save;

      const toggleSwitchId = `${this.key}-toggle`;

      // Map all options for selling plans, selecting the active plan if available.
      const optionItems = this.sellingPlans
        .map((plan) => {
          const selectedPlan =
            this.activeSellingPlan && this.activeSellingPlan.id === plan.id;
          const planName = plan.name.trim();

          return `
        <option value="${plan.id}" ${selectedPlan ? 'selected' : ''}>
          ${planName}
        </option>
      `;
        })
        .join('');

      this.innerHTML = `
      <label class="selling-plan-picker__label" for="${toggleSwitchId}" tabindex="0">
        <span class="toggle-switch">
          <input class="toggle-switch__input" type="checkbox" id="${toggleSwitchId}" ${this.activeSellingPlan ? 'checked' : ''}/>
          <span class="toggle-switch__slider"></span>
        </span>
        ${labelText}
      </label>`;

      if (this.activeSellingPlan) {
        // Selling plan defaults to the first option when enabling, then the user can choose
        // a different subscription interval.
        this.innerHTML += `
        <select class="selling-plan-picker__select">
          ${optionItems}
        </select>
      `;
      }

      // Handle selling plans being added or removed.
      const toggleInput = this.querySelector('.toggle-switch__input');
      toggleInput.addEventListener('click', this.handleSellingPlanToggle);
      const toggleLabel = this.querySelector('.selling-plan-picker__label');
      toggleLabel.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          this.handleSellingPlanToggle(event);
        }
      });
      // Handle selling plans changing allocation (frequency).
      const selectInput = this.querySelector('.selling-plan-picker__select');
      if (selectInput) {
        // Select input may not have been rendered yet.
        selectInput.addEventListener('change', this.handleSellingPlanChange);
      }
    }

    /**
     * Toggle's this line item's current selling plan. If there's an active plan then it's removed,
     * otherwise the first selling plan is assigned to this item.
     */
    handleSellingPlanToggle() {
      if (window.cart.hasBundleByApp()) {
        // Subscriptions cannot mix with bundles by Bundle Builder.
        event.preventDefault();
        this.parentCart.isBusy(false);
        this.parentCart.displayError(
          window.locales.cart.bundle_error_subscription,
        );
        return;
      }

      // Toggle the selling plan off or on. If toggling on then default to the first plan.
      const itemsToChange = this.activeSellingPlan
        ? this.selectSellingPlans(null)
        : this.selectSellingPlans(0);

      this.updateSellingPlans(itemsToChange);
    }

    /**
     * Generates an array of line item objects with a specific selling plan selected.
     * If no index is provided, it creates objects to remove the selling plan.
     *
     * @param {number | null} sellingPlanIndex - The index of the selling plan to select.
     * @returns {Array<Object>} An array of line item objects formatted for a Shopify Cart API request.
     */
    selectSellingPlans(sellingPlanIndex) {
      return [
        {
          id: this.key,
          quantity: this.quantity,
          selling_plan: Number.isFinite(sellingPlanIndex)
            ? this.sellingPlans[sellingPlanIndex].id
            : '',
        },
        ...this.childrenSellingPlans.map((child) => {
          return {
            id: child.key,
            quantity: child.quantity,
            selling_plan: Number.isFinite(sellingPlanIndex)
              ? child.sellingPlans[sellingPlanIndex]
              : '',
          };
        }),
      ];
    }

    /**
     * Update the current selling plan to a different allocation (frequency).
     * @param {Event} event
     */
    handleSellingPlanChange(event) {
      const itemsToChange = this.selectSellingPlans(event.target.selectedIndex);
      this.updateSellingPlans(itemsToChange);
    }

    /**
     * Updates each line item sequentially with Shopify's Cart API, adding or removing selling plans accordingly.
     * @param {Object[]} items - Line items to update.
     */
    async updateSellingPlans(items) {
      this.parentCart.isBusy(true);

      try {
        // Fire each line item change sequentially, they must resolve in order.
        for (const item of items) {
          console.log(`Updating item: ${item.id}`); // For debugging
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(item),
          });
        }
        window.cart.get();
      } catch (error) {
        this.parentCart.displayError(error);
      } finally {
        this.parentCart.isBusy(false);
      }
    }
  }
  customElements.define('selling-plan-picker', SellingPlanPicker);

  /**
   * MiniCartToggle component.
   */
  class MiniCartToggle extends HTMLElement {
    constructor() {
      super();
      this.toggleButton = this.querySelector('.mini-cart-toggle__button');
      this.badgeSpan = this.querySelector('.mini-cart-toggle__badge');
      this.cartBadgeSpan = document.querySelector(
        '.mini-cart__header__item-count',
      );
    }

    connectedCallback() {
      document.addEventListener('cart:get', (event) => {
        this.updateItemCount(event.detail);
      });

      document.addEventListener('cart:update', (event) => {
        this.updateItemCount(event.detail);
      });

      document.addEventListener('cart:clear', (event) => {
        this.updateItemCount(event.detail);
      });

      document.addEventListener('gift-manager:update', (event) => {
        this.updateItemCount(event.detail.cart);
      });

      this.toggleButton.addEventListener('click', (event) => {
        event.preventDefault();
        if (window.location.pathname.includes('/cart')) {
          // Mini-cart does not toggle on the cart page.
          return;
        }
        document.dispatchEvent(new CustomEvent('mini-cart:toggle'));
      });

      // FB-1429 (81071): mirror the drawer's open state onto the button that
      // opens it. The markup declares `aria-expanded="false"` only when the
      // drawer is actually rendered on the page, so this leaves the attribute
      // alone if it was never set (the cart page).
      document.addEventListener('mini-cart:visibility', (event) => {
        if (!this.toggleButton.hasAttribute('aria-expanded')) {
          return;
        }
        this.toggleButton.setAttribute(
          'aria-expanded',
          event.detail.visible ? 'true' : 'false',
        );
      });
    }

    /**
     * Update the badges to reflect how many items are in the cart. A bundle and its
     * items are counted as a single item.
     * @param {Object} cart - Shopify cart object.
     */
    updateItemCount(cart) {
      const badgeParent = this.querySelector('.count_item[data-value]');
      const finalItemCount = cart.items
        .filter(
          // Do not include bundled items in the final item count.
          (item) => !(item.properties && item.properties._is_bundle_item),
        )
        .reduce((sum, item) => sum + item.quantity, 0);

      if (badgeParent) {
        badgeParent.setAttribute('data-value', finalItemCount);
      }

      if (this.badgeSpan) {
        this.badgeSpan.innerText = finalItemCount ? finalItemCount : '';
      }

      if (this.cartBadgeSpan) {
        const itemText =
          finalItemCount === 1
            ? window.locales.cart.item_singular
            : window.locales.cart.item_plural;

        this.cartBadgeSpan.innerText = `${finalItemCount} ${itemText}`;
      }
    }
  }

  customElements.define('mini-cart-toggle', MiniCartToggle);

  /**
   * CartProgressBar component.
   */
  class CartProgressBar extends HTMLElement {
    constructor() {
      super();

      if (!window.cartProgressBar?.milestones?.length) {
        return;
      }
      // Clone the milestones required for this element.
      this.milestones = JSON.parse(
        JSON.stringify(window.cartProgressBar.milestones),
      );
      // Sort milestones by ascending threshold requirement.
      this.milestones.sort((a, b) => a.threshold - b.threshold);
      // A "dummy" first milestone is always needed for piecewise calculation.
      this.milestones.unshift({
        threshold: 0,
        position: 0,
        label: '',
        message: '',
      });
      // Calculate each milestone's position now that division by zero is not a risk.
      this.milestones.forEach((milestone, index) => {
        // Milestones are equally spaced on the progress bar.
        milestone.position = (index / (this.milestones.length - 1)) * 100;
      });
      this.lastMilestone = this.milestones[this.milestones.length - 1];
    }

    connectedCallback() {
      if (!this.milestones || this.milestones.length <= 1) {
        this.remove();
        return;
      }

      this.style.setProperty('--progress', '0%');
      this.style.setProperty(
        '--label-width',
        `${(1 / (this.milestones.length - 1)) * 100}%`,
      );

      this.innerHTML = `
      <div class="cart-progress-bar__message"></div>
      <div class="cart-progress-bar__tracker">
        <div class="cart-progress-bar__tracker__progress"></div>
        <div class="cart-progress-bar__svg-container">
          ${this.drawProgressBar()}
        </div>
        ${this.milestones.map((milestone) => this.renderMilestoneLabel(milestone)).join('')}
      </div>
    `;

      document.addEventListener('cart:get', (event) => {
        this.updateProgress(event.detail);
      });

      const svgContainer = this.querySelector(
        '.cart-progress-bar__svg-container',
      );
      const resizeObserver = new ResizeObserver(() => {
        svgContainer.innerHTML = this.drawProgressBar();
      });

      resizeObserver.observe(svgContainer);
    }

    /**
     * Generate the SVG markup for this progress bar and its milestones.
     * @returns {string} - The template string for this SVG element.
     */
    drawProgressBar() {
      const markerRadius = 4.5;
      const barHeight = 3;

      return `
      <svg class="mask" width="100%" height="32">
        <defs>
          <mask id="cart-progress-bar-mask" x="0" y="0" width="100%" height="100%">
            <rect
              class="cart-progress-bar__svg__mask"
              x="0"
              y="0"
              width="100%"
              height="100%"
            />
            <rect
              x="${markerRadius}"
              y="${markerRadius + barHeight / 2}"
              width="100%"
              height="${barHeight}"
              rx="${barHeight}"
            />
            ${this.milestones.map((milestone) => this.renderMilestoneMarker(milestone, markerRadius))}
          </mask>
        </defs>
        <rect
          class="cart-progress-bar__svg__mask"
          x="0"
          y="0"
          width="100%"
          height="100%"
          mask="url(#cart-progress-bar-mask)"
        />
      </svg>
    `;
    }

    /**
     * Returns a template string for a circle element, representing a milestone marker.
     * @param {Object} milestone - The milestone object to render a marker for.
     * @param {float} radius - The radius for the progress marker.
     * @returns {string} - The template string for this SVG element.
     */
    renderMilestoneMarker(milestone, radius) {
      // Ensure markers stay completely visible.
      const minPosition =
        milestone.position === 0 ? `${radius}px` : `${milestone.position}%`;
      const styles = `
      --max: calc(100% - ${radius}px);
      cx: min(var(--max), ${minPosition});
    `;
      return `
      <circle
        style="${styles}"
        class="cart-progress-bar__svg__marker"
        cy="${3 + radius}"
        r="${radius}"
      />
    `;
    }

    /**
     * Returns a template string for an absolutely positioned milestone label.
     * @param {Object} milestone - The custom milestone object to display the label for.
     * @returns {string} - The template string for this element.
     */
    renderMilestoneLabel(milestone) {
      return `
      <div
        class="cart-progress-bar__tracker__label"
        style="--position: ${milestone.position}%;"
      >
        ${milestone.label}
      </div>
    `;
    }

    /**
     * Update the progress bar based on the cart's final subtotal.
     * @param {Object} cart - Shopify cart object.
     */
    updateProgress(cart) {
      let progress = 0;
      let nextMilestone = null; // Remains null if all milestones are reached.

      if (cart.total_price >= this.lastMilestone.threshold) {
        // Have met or exceeded the final milestone.
        progress = this.lastMilestone.position;
        nextMilestone = null;
      } else {
        // Calculate the progress using a piecewise linear function because while milestones
        // are visually equidistant their "monetary" distances are not.
        for (let i = 0; i < this.milestones.length - 1; i++) {
          const milestone = this.milestones[i];
          nextMilestone = this.milestones[i + 1];

          // Find the correct segment.
          if (
            cart.total_price >= milestone.threshold &&
            cart.total_price < nextMilestone.threshold
          ) {
            // Linear interpolation within this segment.
            const segmentProgress =
              (cart.total_price - milestone.threshold) /
              (nextMilestone.threshold - milestone.threshold);
            progress =
              milestone.position +
              segmentProgress * (nextMilestone.position - milestone.position);
            break;
          }
        }
      }

      // Update the progress bar's main messaging.
      let message = window.cartProgressBar.finalMessage;
      if (nextMilestone) {
        const spendRequired = (
          (nextMilestone.threshold - cart.total_price) /
          100
        ).toFixed(2);
        message = nextMilestone.message.replace('#1', `$${spendRequired}`);
      }
      this.querySelector('.cart-progress-bar__message').innerText = message;
      // Update progress fill.
      this.style.setProperty('--progress', `${progress}%`);
    }
  }
  customElements.define('cart-progress-bar', CartProgressBar);

  // Ordinal labels for "$X away from <ordinal> gift". Beyond ten, fall back to numeric.
  const GIFT_ORDINALS = [
    'first',
    'second',
    'third',
    'fourth',
    'fifth',
    'sixth',
    'seventh',
    'eighth',
    'ninth',
    'tenth',
  ];
  const ordinalForGiftIndex = (index) =>
    GIFT_ORDINALS[index] || `${index + 1}th`;

  const isSubtotalPromo = (promo) =>
    Array.isArray(promo.giftOptions) && promo.giftOptions.length > 0;

  /**
   * FreeGiftPicker component.
   *
   * Handles two promo shapes simultaneously:
   *   - Subtotal promos (multi-option, choose-1-of-N): rendered via addPromoCard().
   *   - Legacy single-product promos (BXGY, free samples): rendered via addProduct().
   */
  class FreeGiftPicker extends ProductPicker {
    constructor() {
      super();
      // Clone and filter the promos this element will manage.
      this.promos = JSON.parse(JSON.stringify(window.gwp.promos));
      this.promos = this.promos
        .map((promo) => {
          if (isSubtotalPromo(promo)) {
            // Drop unavailable bundle-backed options; keep the promo if any options remain.
            promo.giftOptions = promo.giftOptions.filter((option) => {
              const giftBundle = window?.bundleConfig?.[option.giftVariantId];
              if (giftBundle && !giftBundle.available) {
                return false;
              }
              return option.available !== false;
            });
          }
          return promo;
        })
        .filter((promo) => {
          if (Array.isArray(promo.giftOptions)) {
            return promo.giftOptions.length > 0;
          }
          // Legacy single-product (BXGY, free samples) promo.
          const giftBundle = window?.bundleConfig?.[promo.giftVariantId];
          if (giftBundle && !giftBundle.available) {
            return false;
          }
          return true;
        });
      this.locales = {
        title: window.locales.cart.free_gifts_title,
        detail: window.locales.cart.free_gifts_detail,
        upsell: window.locales.cart.free_gifts_upsell_message,
      };
      // Sort the gifts by ascending minimum cart total required.
      this.promos.sort((a, b) => a.minSubtotal - b.minSubtotal);
      this.toggleSelection = this.toggleSelection.bind(this);
      this.toggleOptionSelection = this.toggleOptionSelection.bind(this);
      this.displayUpsellMessage = this.displayUpsellMessage.bind(this);
      this.updateDetailText = this.updateDetailText.bind(this);
    }

    connectedCallback() {
      if (!this.promos.length) {
        this.remove();
        return;
      }

      super.connectedCallback();
      this.setTitleText(this.locales.title);

      this.promos.forEach((promo) => {
        if (isSubtotalPromo(promo)) {
          this.addPromoCard(promo);
          return;
        }
        // Legacy single-product card (BXGY, free samples).
        const pickableProduct = this.addProduct(
          promo.id,
          promo.productDetails.title,
          promo.productDetails.subtitle,
          promo.productDetails.image,
          promo.optionalGiftVariants,
        );
        const toggleButton = pickableProduct.querySelector('button');
        toggleButton.addEventListener('click', this.toggleSelection);
        toggleButton.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            this.toggleSelection(event);
          }
        });
        const giftOptions = pickableProduct.querySelector(
          '.product-picker__variant-options',
        );
        if (giftOptions) {
          giftOptions.addEventListener('change', (event) => {
            const { promoIndex } = event.target.dataset;
            if (!promoIndex) {
              return;
            }
            // Remove any other selected variant.
            this.parentCart.isBusy(true);
            const giftVariant = promo.optionalGiftVariants[promoIndex];
            const giftsToRemove = window.cart.data.items
              .filter((item) => item.product_id === giftVariant.productId)
              .reduce((updates, item) => {
                updates[item.key] = 0;
                return updates;
              }, {});
            window.cart.update(giftsToRemove, true).then(() => {
              this.addGift(promo.optionalGiftVariants[promoIndex]);
            });
          });
        }
      });

      // Run the gift manager every time the cart is fetched.
      document.addEventListener('cart:get', (event) => {
        window.cart.giftManager.run(event.detail);
      });

      // When the gift manager has completed its run this event is triggered.
      document.addEventListener('gift-manager:update', (event) => {
        const cart = event.detail.cart;
        const eligiblePromos = event.detail.eligiblePromos.filter(
          (eligiblePromo) =>
            // Only want promos for this component.
            this.promos.find((promo) => promo.id === eligiblePromo.id),
        );
        this.refresh(cart, eligiblePromos);
      });
    }

    /**
     * Render a "choose 1 of N" card for a subtotal promo. Each option re-uses the existing
     * round-icon button styling by leveraging the .product-picker__item__wrapper /
     * --disabled / --add / --check span markup.
     * @param {Object} promo - Promo with a populated giftOptions array.
     */
    addPromoCard(promo) {
      const card = document.createElement('div');
      card.classList.add('product-picker__item', 'product-picker__group');
      card.setAttribute('data-id', promo.id.toString());
      card.setAttribute('data-disabled', 'true');
      card.setAttribute('data-selected', 'false');

      const groupLabelMarkup = promo.groupLabel
        ? `<div class="product-picker__group__label">${promo.groupLabel}</div>`
        : '';

      const optionsMarkup = promo.giftOptions
        .map(
          (option, index) => `
        <div class="product-picker__option" data-option-index="${index}" data-disabled="true" data-selected="false">
          <div class="product-picker__item__wrapper">
            ${
              option.image
                ? `<img src="${option.image}" width="56" height="56" alt="" loading="lazy"/>`
                : ''
            }
            <div>
              <div class="product-picker__item__title">${option.title}</div>
              ${
                option.subheading
                  ? `<div class="product-picker__item__subtitle">${option.subheading}</div>`
                  : ''
              }
            </div>
            <button type="button" aria-label="${window.locales.cart.toggle_product}">
              <span class="product-picker__icon product-picker__icon--disabled">
                ${disabledIcon}
              </span>
              <span class="product-picker__icon product-picker__icon--add">
                ${disabledIcon}
              </span>
              <span class="product-picker__icon product-picker__icon--check">
                ${radioOnIcon}
              </span>
            </button>
          </div>
        </div>
      `,
        )
        .join('');

      card.innerHTML = `
      <div class="product-picker__group__wrapper">
        <div class="product-picker__group__header">
          ${groupLabelMarkup}
          <div class="product-picker__group__status"></div>
        </div>
        <div class="product-picker__group__options">
          ${optionsMarkup}
        </div>
      </div>
    `;

      card.querySelectorAll('.product-picker__option button').forEach(
        (button) => {
          button.addEventListener('click', this.toggleOptionSelection);
          button.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              this.toggleOptionSelection(event);
            }
          });
        },
      );

      this.swiperWrapper.insertAdjacentElement('beforeend', card);
      return card;
    }

    /**
     * Refresh this element with the latest cart and validated gifts.
     * @param {Object} cart - Shopify cart object.
     * @param {Array<Object>} eligiblePromos - Array of GiftManager promos that are eligible.
     */
    refresh(cart, eligiblePromos) {
      this.parentCart.isBusy(true);
      this.updateDetailText(cart, eligiblePromos);

      // Reset every card and option to a disabled, unselected state.
      this.querySelectorAll('.product-picker__item').forEach((card) => {
        card.setAttribute('data-disabled', 'true');
        card.setAttribute('data-selected', 'false');
        // Legacy/BXGY cards have a single top-level button.
        const legacyButton = card.querySelector(
          ':scope > .product-picker__item__wrapper > button',
        );
        if (legacyButton) {
          legacyButton.setAttribute('disabled', 'disabled');
        }
        // Subtotal cards have per-option buttons.
        card.querySelectorAll('.product-picker__option').forEach((option) => {
          option.setAttribute('data-disabled', 'true');
          option.setAttribute('data-selected', 'false');
          const optionButton = option.querySelector('button');
          if (optionButton) {
            optionButton.setAttribute('disabled', 'disabled');
          }
        });
      });

      // Update the per-card status line for every subtotal promo (eligible or not).
      // Ordinal indexing follows ascending minSubtotal, including ineligible offers.
      const subtotalPromos = this.promos.filter(isSubtotalPromo);
      const subtotalIndexById = new Map(
        subtotalPromos.map((p, i) => [p.id, i]),
      );
      this.promos.forEach((promo) => {
        if (!isSubtotalPromo(promo)) return;
        const card = this.querySelector(
          `.product-picker__item[data-id="${promo.id}"]`,
        );
        if (!card) return;
        const status = card.querySelector('.product-picker__group__status');
        if (!status) return;
        if (cart.total_price >= promo.minSubtotal) {
          status.textContent = promo.selectCtaLabel || 'SELECT YOUR GIFT';
          status.classList.add('product-picker__group__status--eligible');
          status.classList.remove('product-picker__group__status--ineligible');
        } else {
          const dollarsAway =
            '$' +
            ((promo.minSubtotal - cart.total_price) / 100)
              .toFixed(2)
              .replace('.00', '');
          const ordinal = ordinalForGiftIndex(
            subtotalIndexById.get(promo.id) || 0,
          );
          status.textContent = `${dollarsAway} away from ${ordinal} gift`;
          status.classList.add('product-picker__group__status--ineligible');
          status.classList.remove('product-picker__group__status--eligible');
        }
      });

      eligiblePromos.forEach((promo) => {
        const card = this.querySelector(
          `.product-picker__item[data-id="${promo.id}"]`,
        );
        if (!card) return;
        card.setAttribute('data-disabled', 'false');
        const legacyButton = card.querySelector(
          ':scope > .product-picker__item__wrapper > button',
        );
        if (legacyButton) {
          legacyButton.removeAttribute('disabled');
        }

        if (isSubtotalPromo(promo)) {
          // Find which (if any) of the promo's options is currently in the cart. The card
          // itself stays at data-selected="false" — only the per-option data-selected matters
          // here. Setting it on the card would cascade into the legacy
          // `.product-picker__item[data-selected="true"] .product-picker__icon--add { display:none }`
          // rule and hide the green-ring icon on every unselected sibling option.
          let selectedIndex = -1;
          promo.giftOptions.forEach((option, idx) => {
            const inCart = cart.items.some(
              (item) =>
                item.properties?.Gift &&
                item.properties?._promo_id === promo.id &&
                item.properties?._component === this.name &&
                (item.variant_id === option.giftVariantId ||
                  item.product_id === option.productId),
            );
            if (inCart) selectedIndex = idx;
          });
          card.querySelectorAll('.product-picker__option').forEach(
            (optionEl) => {
              optionEl.setAttribute('data-disabled', 'false');
              const optionButton = optionEl.querySelector('button');
              if (optionButton) optionButton.removeAttribute('disabled');
              const idx = parseInt(optionEl.dataset.optionIndex, 10);
              optionEl.setAttribute(
                'data-selected',
                idx === selectedIndex ? 'true' : 'false',
              );
            },
          );
          return;
        }

        // Legacy single-product card.
        const giftInCart = cart.items.find(
          (item) =>
            item.properties?.Gift &&
            item.product_id.toString() === promo.productId.toString() &&
            item.properties?._component === this.name,
        );
        if (giftInCart) {
          card.setAttribute('data-selected', 'true');
        } else {
          this.clearVariantSelection(promo);
        }
      });

      this.displayUpsellMessage(cart.total_price);
      this.parentCart.isBusy(false);
    }

    /**
     * Update this element's title detail to indicate how many gifts are selected.
     * @param {Object} cart - Shopify cart object.
     * @param {Array<Object>} eligiblePromos - GiftManager promos that are eligible with the latest cart.
     */
    updateDetailText(cart, eligiblePromos) {
      const eligibleGiftProductIds = eligiblePromos.reduce((ids, promo) => {
        if (isSubtotalPromo(promo)) {
          promo.giftOptions.forEach((option) =>
            ids.push(option.productId.toString()),
          );
        } else if (promo.productId) {
          ids.push(promo.productId.toString());
        }
        return ids;
      }, []);
      const totalGiftsInCart = cart.items
        .filter((item) => {
          if (
            item.properties?.Gift &&
            item.properties?._component === this.name
          ) {
            return (
              eligibleGiftProductIds.indexOf(item.product_id.toString()) > -1
            );
          }
          return false;
        })
        .reduce((sum, gift) => sum + gift.quantity, 0);
      const maxAllowedGifts = eligiblePromos.reduce(
        (sum, gift) => sum + gift.giftQuantity,
        0,
      );
      const detailText = this.locales.detail
        .replace('#1', totalGiftsInCart)
        .replace('#2', maxAllowedGifts);

      this.setDetailText(detailText);
    }

    /**
     * Toggle the selection for a legacy single-product card (BXGY, free samples).
     * @param {Event} event
     */
    toggleSelection(event) {
      event.preventDefault();

      const pickableProduct = event.target.closest(
        '.product-picker__item[data-id]',
      );
      if (!pickableProduct) {
        return;
      }
      const promo = this.promos.find(
        (promo) => promo.id === pickableProduct.getAttribute('data-id'),
      );
      if (!promo) {
        return;
      }
      if (pickableProduct.getAttribute('data-disabled') === 'true') {
        return;
      }
      if (pickableProduct.getAttribute('data-selected') === 'false') {
        this.addGift(promo);
        return;
      }

      this.removeGift(promo);
    }

    /**
     * Toggle a single option within a subtotal-promo card. Enforces 1-of-N at the UI layer
     * by optimistically flipping siblings' state before the network round trip.
     * @param {Event} event
     */
    toggleOptionSelection(event) {
      event.preventDefault();

      const optionEl = event.target.closest(
        '.product-picker__option[data-option-index]',
      );
      const card = event.target.closest('.product-picker__item[data-id]');
      if (!optionEl || !card) {
        return;
      }
      if (card.getAttribute('data-disabled') === 'true') {
        return;
      }
      const promo = this.promos.find(
        (p) => p.id === card.getAttribute('data-id'),
      );
      if (!promo) {
        return;
      }
      const optionIndex = parseInt(optionEl.dataset.optionIndex, 10);
      const option = promo.giftOptions[optionIndex];
      if (!option) {
        return;
      }
      const wasSelected = optionEl.getAttribute('data-selected') === 'true';

      // Optimistic UI: flip every option in this card to deselected, then reflect the new
      // state on the clicked option only. We deliberately do NOT mirror selection onto the
      // card itself — the legacy `.product-picker__item[data-selected="true"]` rules would
      // cascade into every sibling option and hide their unselected radio.
      card.querySelectorAll('.product-picker__option').forEach((sibling) => {
        sibling.setAttribute('data-selected', 'false');
      });
      if (!wasSelected) {
        optionEl.setAttribute('data-selected', 'true');
      }

      this.parentCart.isBusy(true);

      const giftsInCart =
        window.cart.data?.items?.filter(
          (item) => item.properties && item.properties._promo_id === promo.id,
        ) || [];

      const removalUpdates = giftsInCart.reduce((updates, item) => {
        updates[item.key] = 0;
        return updates;
      }, {});

      const removeFirst =
        Object.keys(removalUpdates).length > 0
          ? window.cart.update(removalUpdates, true)
          : Promise.resolve();

      removeFirst.then(() => {
        if (wasSelected) {
          // Same option clicked while selected — deselect only; refresh state.
          window.cart.giftManager.run(window.cart.data);
          return;
        }
        this.addGift(promo, option);
      });
    }

    /**
     * Add the gifts associated with this promo. For subtotal promos, the chosen option's
     * variant id and key are used; otherwise the promo's own giftVariantId / key.
     * @param {Object} promo - GiftManager promo object.
     * @param {Object} [option] - Selected option from promo.giftOptions, if applicable.
     */
    addGift(promo, option = null) {
      const giftVariantId = option ? option.giftVariantId : promo.giftVariantId;
      const giftQuantity = option
        ? option.giftQuantity || promo.giftQuantity
        : promo.giftQuantity;
      const giftKey = option ? option.key : promo.key;

      const giftsToAdd = [];
      // Some gifts may be a bundle, so its children must be added as gifts, too.
      if (
        window.getBundleItems &&
        window.bundleConfig &&
        window.bundleConfig[giftVariantId]
      ) {
        const bundle = window.getBundleItems(giftVariantId, giftQuantity);
        giftsToAdd.push(
          ...bundle.map((item) => {
            item.properties.Gift = 'Free';
            item.properties._promo_id = promo.id;
            item.properties._component = this.name;
            item.properties._key = giftKey;
            return item;
          }),
        );
      } else {
        giftsToAdd.push({
          id: giftVariantId,
          quantity: giftQuantity,
          properties: {
            Gift: 'Free',
            _promo_id: promo.id,
            _component: this.name,
            _key: giftKey,
          },
        });
      }

      if (giftsToAdd.length) {
        this.parentCart.isBusy(true);
        window.cart
          .addItems(giftsToAdd, true)
          .then((cart) => window.cart.giftManager.run(cart));
        // Parent cart is no longer busy when `gift-manager:update`
        // triggers this custom element to refresh.
      }
    }

    /**
     * Remove the gifts associated with this promo.
     * @param {Object} promo - GiftManager promo object.
     */
    removeGift(promo) {
      const giftsInCart = window.cart.data.items.filter(
        (item) => item.properties && item.properties._promo_id === promo.id,
      );
      if (!giftsInCart.length) {
        return;
      }
      const giftsToRemove = giftsInCart.reduce((updates, item) => {
        updates[item.key] = 0;
        return updates;
      }, {});

      this.parentCart.isBusy(true);
      this.clearVariantSelection(promo);

      window.cart
        .update(giftsToRemove, true)
        .then((cart) => window.cart.giftManager.run(cart));
    }

    /**
     * Display a message for the next unlockable gift to incentivize the user. Subtotal promos
     * surface this through the per-card status line in refresh(); only legacy promos use the
     * floating upsell banner here.
     * @param {number} cartTotalPrice - Cart total in pennies.
     */
    displayUpsellMessage(cartTotalPrice) {
      if (!this.locales.upsell) {
        return;
      }
      this.querySelectorAll('.product-picker__upsell').forEach((element) =>
        element.remove(),
      );
      const upcomingPromos = this.promos.filter(
        (promo) =>
          !isSubtotalPromo(promo) && cartTotalPrice < promo.minSubtotal,
      );
      if (!upcomingPromos.length) {
        return;
      }

      let firstMessageDisplayed = false;
      upcomingPromos.forEach((promo) => {
        const pickableProduct = this.querySelector(
          `.product-picker__item[data-id="${promo.id}"]`,
        );
        if (!pickableProduct) {
          return;
        }
        const spendDollarAmount =
          '$' +
          ((promo.minSubtotal - cartTotalPrice) / 100)
            .toFixed(2)
            .replace('.00', '');

        const upsellElement = document.createElement('div');
        upsellElement.classList.add('product-picker__upsell');

        if (!firstMessageDisplayed) {
          upsellElement.classList.add('product-picker__upsell--first');
          firstMessageDisplayed = true;
        }

        upsellElement.innerText = this.locales.upsell.replace(
          '{{ amount }}',
          spendDollarAmount,
        );
        pickableProduct.insertAdjacentElement('afterbegin', upsellElement);
      });
    }
  }
  customElements.define('free-gift-picker', FreeGiftPicker);

  /**
   * FreeSamplePicker component.
   */
  class FreeSamplePicker extends FreeGiftPicker {
    constructor() {
      super();
      this.promos = JSON.parse(JSON.stringify(window.freeSamples.promos));
      this.locales = {
        title: window.locales.cart.free_samples_title,
        detail: window.locales.cart.free_samples_detail,
        // No upsell message for free samples.
      };
    }
  }
  customElements.define('free-sample-picker', FreeSamplePicker);

  /**
   * SuggestedProductPicker component.
   */
  class SuggestedProductPicker extends ProductPicker {
    constructor() {
      super();
      const { products, settings } = window.suggestedProducts;

      this.maxSuggestions = settings.max;
      this.products = products || []; // The final group of products to suggest.
      this.ignoredIds = settings.ignoredIds;
      this.ignoredTags = settings.ignoredTags;
      this.targetProductId = settings.targetProductId;
      this.selectProduct = this.selectProduct.bind(this);

      this.shuffleArray(this.products);
    }

    /**
     * Shuffles an array in place using the Fisher-Yates algorithm.
     * @param {Array} arr - The array to shuffle, modified directly.
     */
    shuffleArray(arr) {
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        // Swap.
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
    }

    connectedCallback() {
      super.connectedCallback();

      fetch(
        `/recommendations/products.json?product_id=${this.targetProductId}&intent=related`,
      )
        .then((response) => response.json())
        .then(({ products }) => {
          if (!products) {
            return;
          }
          const fetchedProducts = products.filter(
            (product) =>
              // Remove any product that's already mentioned as a backfill recommendation.
              !this.products.find(
                (backfillProduct) => backfillProduct.id === product.id,
              ),
          );

          this.shuffleArray(fetchedProducts);
          this.products.unshift(...fetchedProducts);

          this.products.filter((product) => {
            // Remove any product that's tagged as such.
            if (product.tags.some((tag) => this.ignoredTags.includes(tag))) {
              return false;
            }

            // Remove any product that's already in the cart.
            if (this.ignoredIds.includes(product.id)) {
              return false;
            }

            // Remove any product that's priced as $0.
            if (product.price === 0) {
              return false;
            }

            // Remove any product that is not available.
            if (!product.available) {
              return false;
            }

            // Remove any product that's of type "Custom Bundle".
            if (product.type === 'Custom Bundle') {
              return false;
            }

            // Do not include any static bundle that is unavailable.
            if (window.bundleConfig) {
              const bundle = window.bundleConfig[product.id.toString()];
              if (bundle && !bundle.available) {
                return false;
              }
            }

            // Include the product if all conditions pass.
            return true;
          });
        })
        .catch((error) => {
          console.error('Failed to fetch product suggestions:', error);
        })
        .finally(() => {
          if (!this.products.length) {
            this.remove();
            return;
          }

          this.setTitleText(window.locales.cart.suggested_products_title);
          const maxProducts = Math.min(
            this.maxSuggestions,
            this.products.length,
          );

          this.products.slice(0, maxProducts).forEach((product) => {
            const firstAvailableVariant = product.variants.find(
              (variant) => variant.available,
            );
            const pickableProduct = this.addProduct(
              firstAvailableVariant.id,
              product.title,
              '$' + (firstAvailableVariant.price / 100).toFixed(2),
              product.featured_image + '&=112',
            );
            pickableProduct.classList.add('product-picker__item--with-price');
            const toggleButton = pickableProduct.querySelector('button');
            toggleButton.addEventListener('click', this.selectProduct);
            toggleButton.addEventListener('keydown', (event) => {
              if (event.key === 'Enter') {
                this.selectProduct(event);
              }
            });
          });

          // Initialize the component for rendering.
          this.initialize(
            this.closest('mini-cart'),
            window.suggestedProducts.settings,
          );
        });
    }

    /**
     * Add the suggested product or a bundle and its items to cart.
     * @param {Event} event
     */
    selectProduct(event) {
      event.preventDefault();

      const pickableProduct = event.target.closest(
        '.product-picker__item[data-id]',
      );
      if (!pickableProduct) {
        return;
      }
      const variantId = pickableProduct.getAttribute('data-id');
      if (!variantId) {
        return;
      }
      const itemsToAdd = [];

      if (
        window.getBundleItems &&
        window.bundleConfig &&
        window.bundleConfig[variantId]
      ) {
        itemsToAdd.push(...window.getBundleItems(variantId, 1));
      } else {
        itemsToAdd.push({
          id: variantId,
          quantity: 1,
        });
      }

      pickableProduct.setAttribute('data-selected', 'true');
      this.parentCart.isBusy(true);
      // The parent cart will no longer be busy when this promise resolves.
      window.cart.addItems(itemsToAdd).then(() => {
        // The selection resets after its been added to cart.
        pickableProduct.setAttribute('data-selected', 'false');
      });
    }
  }
  customElements.define('suggested-product-picker', SuggestedProductPicker);

  /**
   * CartLineItem component.
   */
  class CartLineItem extends HTMLElement {
    constructor() {
      super();

      this.parentCart = null; // The cart that instantiated this custom element.
      this.key = null; // This line item's key.
      this.quantity = null; // The quantity for this line item.
      this.sku = null; // This line item's SKU;
      this.childrenItems = []; // This parent's children items, if it's a bundle.

      // Elements that require event listeners.
      this.item = null;
      this.removeButton = null;
      this.quantityInput = null;
      this.decreaseQuantityButton = null;
      this.increaseQuantityButton = null;

      // Event handlers.
      this.handleRemoveClick = this.handleRemoveClick.bind(this);
      this.handleQuantityInput = this.handleQuantityInput.bind(this);
      this.handleDecreaseClick = this.handleDecreaseClick.bind(this);
      this.handleIncreaseClick = this.handleIncreaseClick.bind(this);
    }

    /**
     * Construct this line item's DOM as soon as it's available after creation.
     */
    connectedCallback() {
      this.innerHTML = `
      <div>
        <img class="cart-line-item__image" width="72" height="72"/>
        <div class="cart-line-item__details">
          <div class="cart-line-item__details__row">
            <a class="cart-line-item__title"></a>
            <div class="cart-line-item__price">
              <div class="cart-line-item__price__final"></div>
              <div class="cart-line-item__price__strike"></div>
            </div>
          </div>
          <div class="cart-line-item__details__row">
            <selling-plan-picker/>
          </div>
          <div class="cart-line-item__details__row">
            <div class="cart-line-item__quantity">
              <button
                class="cart-line-item__quantity__button event_update_quantity"
                data-action="decrease"
                aria-label="${window.locales.cart.decrease}"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 1" width="8" height="1">
                  <path stroke="#231F20" d="M0 .5h8"/>
                </svg>
              </button>
              <input class="cart-line-item__quantity__input" type="number" aria-label="${window.locales.cart.quantity}">
              <button
                class="cart-line-item__quantity__button event_update_quantity"
                data-action="increase"
                aria-label="${window.locales.cart.increase}"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 8" width="8" height="8">
                  <path stroke="#231F20" d="M0 4h8M4 8V0"/>
                </svg>
              </button>
            </div>
            <button class="cart-line-item__remove event_remove_from_cart">
              ${window.locales.cart.remove}
            </button>
          </div>
        </div>
      </div>
      <bundled-items/>
    `;

      // Assign interactive elements.
      this.removeButton = this.querySelector('.cart-line-item__remove');
      this.quantityInput = this.querySelector(
        '.cart-line-item__quantity__input',
      );
      this.decreaseQuantityButton = this.querySelector(
        '.cart-line-item__quantity__button[data-action="decrease"]',
      );
      this.increaseQuantityButton = this.querySelector(
        '.cart-line-item__quantity__button[data-action="increase"]',
      );

      // Setup event listeners.
      this.removeButton.addEventListener('click', this.handleRemoveClick);
      this.quantityInput.addEventListener('click', this.handleQuantityInput);
      this.quantityInput.addEventListener('blur', this.handleQuantityInput);
      this.decreaseQuantityButton.addEventListener(
        'click',
        this.handleDecreaseClick,
      );
      this.increaseQuantityButton.addEventListener(
        'click',
        this.handleIncreaseClick,
      );
    }

    /**
     * Initialize or refresh this element with the latest data from the line item object.
     * @param {Object} item - Cart line item object.
     * @param {MiniCart} parentCart - The cart component that owns this line item.
     */
    initialize(item, parentCart) {
      this.item = item;
      this.parentCart = parentCart;
      this.key = item.key;
      this.quantity = item.quantity;
      this.sku = item.sku;

      // Render this product's bundled items if present.
      const bundledItems = this.querySelector('bundled-items');
      if (item.properties._group) {
        // Find all children items that belong to this line item's group.
        this.childrenItems = window.cart.data.items.filter((otherItem) => {
          return (
            otherItem.properties._is_bundle_item &&
            otherItem.properties._group === item.properties._group
          );
        });
        // Dynamically priced bundles do not allow quantity changes, but static bundles do
        item.selling_plan_allocation
          ? this.querySelector('.cart-line-item__quantity')?.remove()
          : null;
        bundledItems.initialize(this.childrenItems);
      } else if (item.properties._rb_id) {
        // This single item represents an entire bundle by the Bundle Builder app.
        // Its children items need to be mocked in order to use this custom element.
        const contentsString = item.properties.Contents || '';
        const mockChildrenItems = contentsString
          .split(',')
          .map((part) => part.trim())
          .map((value, index) => {
            // Match patterns like "2x Item"
            const quantityMatch = value.match(/^(\d+)x (.+)$/);

            let quantity, title;

            if (quantityMatch) {
              quantity = parseInt(quantityMatch[1], 10);
              title = quantityMatch[2];
            } else {
              // No quantity -> default to 1
              quantity = 1;
              title = value;
            }

            // Use per-item image if available, fall back to parent bundle image
            const itemImageUrl = item.properties[`_img_${index}`];
            const featured_image = itemImageUrl
              ? { url: itemImageUrl, alt: title }
              : item.featured_image;

            return {
              product_title: title,
              quantity,
              featured_image,
              properties: {
                _bundle_quantity_multiplier: quantity,
              },
            };
          })
          .filter(Boolean);
        bundledItems.initialize(mockChildrenItems);
      } else {
        bundledItems.remove();
      }

      // Initialize the selling plan picker early since it has to do its own fetching.
      const sellingPlanPicker = this.querySelector('selling-plan-picker');
      if (sellingPlanPicker) {
        // This component may have already been removed if there's no selling plans available.
        sellingPlanPicker.initialize(item, this.parentCart, this.childrenItems);
      }

      // Product image.
      const imageLoading = this.parentCart.isVisible ? 'eager' : 'lazy';
      const image = this.querySelector('.cart-line-item__image');
      image.setAttribute('src', `${item.featured_image.url}&width=144`);
      image.setAttribute('loading', imageLoading);
      image.setAttribute('alt', item.featured_image.alt);

      // Product link and title.
      const linkedTitle = this.querySelector('.cart-line-item__title');
      linkedTitle.innerText = item.product_title;
      linkedTitle.href = item.url;

      // Pricing display.
      let finalPrice = 0;
      let originalPrice = 0;

      if (this.childrenItems && item.properties._rc_bundle) {
        // Set the latest pricing details for this parent based on its children's pricing.
        this.childrenItems.forEach((item) => {
          finalPrice += item.final_line_price;
          originalPrice += item.original_line_price;
        });
      }

      if (item.properties?._original_bundle_price) {
        originalPrice = item.properties._original_bundle_price;
      } else if (item.selling_plan_allocation?.compare_at_price) {
        originalPrice = item.selling_plan_allocation.compare_at_price * item.quantity;
      } else if (item.original_line_price > item.final_line_price) {
        originalPrice = item.original_line_price;
      }

      this.displayStrikePrice(originalPrice);

      // Final line price.
      const itemPrice =
        finalPrice || item.properties?._bundle_price || item.final_line_price;
      const formattedFinalPrice = '$' + (itemPrice / 100).toFixed(2);
      const linePrice = this.querySelector('.cart-line-item__price__final');
      linePrice.innerText = formattedFinalPrice;

      // Quantity input and increase/decrease buttons.
      this.quantityInput.setAttribute('data-action-detail', item.sku);
      this.quantityInput.setAttribute('value', this.quantity);
      this.decreaseQuantityButton.setAttribute('data-action-detail', item.sku);
      this.increaseQuantityButton.setAttribute('data-action-detail', item.sku);
    }

    /**
     * Updates the quantity for this line item, pushing any necessary data layer events.
     * @param {Event} event
     * @param {number} quantity - The new quantity for this line item.
     */
    changeQuantity(event, quantity) {
      if (quantity <= 0) {
        this.handleRemoveClick(event);
        return;
      }

      this.parentCart.isBusy(true);
      event.preventDefault();

      const allUpdates = {
        [this.key]: quantity,
        // Modify the quantities for any children items belonging to this line item.
        ...this.childrenItems.reduce((updates, childItem) => {
          const multiplier =
            childItem.properties._bundle_quantity_multiplier || 1;
          updates[childItem.key] = multiplier * quantity;
          return updates;
        }, {}),
      };

      window.cart
        .update(allUpdates)
        .then(() => {
          const quantityDelta = quantity - this.quantity;

          if (this.sku && window.dataLayer) {
            const updateType = quantityDelta > 0 ? 'increase' : 'decrease';

            window.dataLayer.push({
              event: 'gtmEvent',
              event_name: 'cart_quantity_update',
              update_type: updateType,
              old_quantity: this.quantity,
              new_quantity: quantity,
            });
          }

          this.dispatchQuantityChange(quantityDelta);

          return window.cart.get();
        })
        .finally(() => {
          this.parentCart.isBusy(false);
        });
    }

    /**
     * Reports a quantity change to the data layer as an add or a remove. Raising a line
     * item's quantity is an Add to Cart and lowering it is a Remove from Cart, each covering
     * only the amount the line changed by rather than its resulting total. Bundle children
     * are included alongside their parent so the reported value stays accurate for bundles
     * whose parent line is priced at $0.
     * @param {number} quantityDelta - The signed amount this line item's quantity changed by.
     */
    dispatchQuantityChange(quantityDelta) {
      if (!quantityDelta || !this.item) {
        return;
      }

      const changedQuantity = Math.abs(quantityDelta);
      const items = [
        { ...this.item, quantity: changedQuantity },
        ...this.childrenItems.map((childItem) => ({
          ...childItem,
          quantity:
            (childItem.properties._bundle_quantity_multiplier || 1) *
            changedQuantity,
        })),
      ];

      document.dispatchEvent(
        new CustomEvent(
          quantityDelta > 0
            ? 'add_to_cart_success'
            : 'remove_from_cart_success',
          { detail: { items } },
        ),
      );
    }

    /**
     * Handles the removal of this line item, then triggers the mini-cart to refresh.
     * @param {Event} event
     */
    handleRemoveClick(event) {
      this.parentCart.isBusy(true);
      event.preventDefault();

      const allUpdates = {
        [this.key]: 0,
        // Remove any children items belonging to this line item.
        ...this.childrenItems.reduce((updates, childItem) => {
          updates[childItem.key] = 0;
          return updates;
        }, {}),
      };

      window.cart
        .update(allUpdates)
        .then(() => {
          document.dispatchEvent(
            new CustomEvent('remove_from_cart_success', {
              detail: this.item,
            }),
          );
          window.cart.get();
        })
        .finally(() => this.parentCart.isBusy(false));
    }

    /**
     * Handles the direct manual change to this line item's quantity.
     * @param {Event} event
     */
    handleQuantityInput(event) {
      const targetValue = event.target.value.trim();
      const targetQuantity =
        targetValue === '' ? this.quantity : parseInt(event.target.value, 10);

      if (targetQuantity === this.quantity) {
        // No change, but ensure the input value is matches this quantity.
        event.preventDefault();
        event.target.setAttribute('value', this.quantity);
        return;
      }

      this.changeQuantity(event, targetQuantity);
    }

    /**
     * Decreases this line item's quantity by one.
     * @param {Event} event
     */
    handleDecreaseClick(event) {
      this.changeQuantity(event, this.quantity - 1);
    }

    /**
     * Increases this line item's quantity by one.
     * @param {Event} event
     */
    handleIncreaseClick(event) {
      this.changeQuantity(event, this.quantity + 1);
    }

    /**
     * Display a strikethrough price for this item.
     * @param {number} price - The strike price in pennies.
     */
    displayStrikePrice(price) {
      if (!Number.isFinite(price) || price <= 0) {
        return;
      }
      // Only display the original (strike) price if there's an actual savings.
      const formattedStrikePrice = '$' + (price / 100).toFixed(2);
      const strikePrice = this.querySelector('.cart-line-item__price__strike');
      strikePrice.innerText = formattedStrikePrice;
    }
  }
  customElements.define('cart-line-item', CartLineItem);

  /**
   * The shared dialog/focus-management primitive, registered by
   * `assets/custom-a11y-dialog.js` as the `xFocusElement` Alpine store.
   *
   * FB-1429 (81082, 81083, 81201, 81203, 81218, 81220, 81222): the mini-cart
   * used to own a private focus trap that had the same defects as the theme's
   * — an unfiltered `querySelectorAll` that treated hidden elements as trap
   * boundaries, and no background hiding at all. Rather than fix the same bug
   * a second time, the drawer now routes focus through the corrected shared
   * store, which every other overlay in the theme already uses.
   *
   * Returns null when Alpine has not initialized yet, so callers keep a
   * degraded-but-working fallback instead of throwing.
   */
  const getFocusStore = () => {
    try {
      return window.Alpine?.store('xFocusElement') ?? null;
    } catch (error) {
      return null;
    }
  };

  /**
   * MiniCart component
   */
  class MiniCart extends HTMLElement {
    constructor() {
      super();
      this.isFullPage = this.classList.contains('mini-cart--full-page');
      this.isVisible = this.isFullPage ? true : false;
      this.fixedOverlay = document.createElement('div');
      this.previouslyFocusedElement = null;
      this.checkoutForm = null;
      this.refreshCartItems = this.refreshCartItems.bind(this);
      this.displayError = this.displayError.bind(this);
      this.handleCheckout = this.handleCheckout.bind(this);
      this.suggestedProductPicker = null;
      this.statusRegion = null;
    }

    connectedCallback() {
      // Set initial state.
      this.setAttribute('data-is-visible', this.isVisible);

      // FB-1429 (81201, 81203, 81218, 81220, 81222): the closed drawer is only
      // moved off-canvas (`transform: translateX(100%)`), so it stays rendered
      // and every control inside it stayed in the page's tab order — the empty-
      // cart "Continue shopping" link, the suggested-products <summary>, the
      // Swiper pagination bullets and the Afterpay "More Info" link were all
      // reachable by Tab from the page behind the drawer. Marking the closed
      // drawer inert removes it from focus, pointer and AT in one attribute.
      this.setHidden(!this.isVisible);

      this.statusRegion = this.querySelector('.mini-cart__status');

      // Set up the fixed overlay that will appear behind the mini-cart when its visible.
      this.fixedOverlay.classList.add('mini-cart__overlay');
      // FB-1429 (81080): the auditor flagged this overlay as a dialog missing
      // its role, because it is what appears when the drawer opens. It is a
      // backdrop, not the dialog — the dialog is <mini-cart> itself, which is
      // where the role, the modal flag and the accessible name go. The backdrop
      // holds no content, so it is hidden from AT instead.
      //
      // `data-a11y-dialog-backdrop` opts it out of the primitive's inert sweep.
      // `inert` blocks pointer events as well as focus, so marking it would
      // silently break click-outside-to-close.
      this.fixedOverlay.setAttribute('aria-hidden', 'true');
      this.fixedOverlay.setAttribute('data-a11y-dialog-backdrop', '');
      this.insertAdjacentElement('afterend', this.fixedOverlay);

      // Dismiss only button.
      this.dismissButton = this.querySelector('.mini-cart__header__close');
      this.dismissButton.addEventListener('click', () => {
        this.toggleVisibility();
      });

      // Initialize the FreeGiftPicker.
      const freeGiftPicker = this.querySelector('free-gift-picker');
      if (freeGiftPicker) {
        freeGiftPicker.initialize(this, window.gwp.settings);
      }

      // Initialize the FreeSamplePicker.
      const freeSamplePicker = this.querySelector('free-sample-picker');
      if (freeSamplePicker) {
        freeSamplePicker.initialize(this, window.freeSamples.settings);
      }

      // Get a reference to SuggestedProductPicker. It initializes itself after fetching products.
      this.suggestedProductPicker = this.querySelector(
        'suggested-product-picker',
      );

      // Totals get updated each time the cart is fetched.
      this.checkoutTotalSpans = this.querySelectorAll(
        '.mini-cart__checkout__total',
      );
      document.addEventListener('cart:get', (event) => {
        const bundlePrices = event.detail.items
          .filter((item) => item.properties?._bundle_price)
          .filter(
            (item) => item.properties._bundle_price !== item.final_line_price,
          )
          .reduce((sum, item) => (sum += item.properties._bundle_price), 0);
        const totalPrice = event.detail.total_price + bundlePrices;

        this.checkoutTotalSpans.forEach((span) => {
          span.innerText = '$' + (totalPrice / 100).toFixed(2).toString();
        });
      });

      // Display the cart whenever an item is added.
      document.addEventListener('cart:add', () => {
        this.isBusy(true);
        if (!this.isVisible) {
          this.toggleVisibility();
        }
      });

      // Evaluate cart line items whenever the cart is fetched.
      this.lineItemSection = this.querySelector('.mini-cart__line-items');
      document.addEventListener('cart:get', (event) => {
        this.updateEmptyState(event.detail);
        this.refreshCartItems(event.detail);
        this.isBusy(false);
        this.announce(this.statusSummary(event.detail));
      });

      // Update the cart's empty state whenever the gift manager makes changes.
      document.addEventListener('gift-manager:update', (event) => {
        this.updateEmptyState(event.detail.cart);
      });

      // Handle events when the cart is toggled.
      document.addEventListener('mini-cart:toggle', () => {
        // This event is the primary mechanism for activating the mini-cart.
        this.toggleVisibility();
      });

      // FB-1429 (81083): Escape and Tab containment are handled by the shared
      // dialog primitive while the trap is engaged. The primitive dispatches
      // `a11y-dialog:close` on Escape; the drawer only has to close itself.
      //
      // The private `keydown` listener this replaces bound Escape and its own
      // Tab trap on `document` for the life of the page. Handling Escape here
      // as well would close the drawer twice — the second call re-opens it.
      this.addEventListener('a11y-dialog:close', () => {
        if (this.isFullPage || !this.isVisible) {
          return;
        }
        this.toggleVisibility();
      });

      // Dimiss the cart if the overlay gets clicked.
      this.fixedOverlay.addEventListener('click', () => {
        this.toggleVisibility();
      });

      // Display any error messages for the mini-cart.
      document.addEventListener('mini-cart:display-error', (event) => {
        // Resolve with the latest cart before displaying the error message.
        window.cart.get().then(() => {
          this.displayError(event.detail);
        });
      });

      // Handle checkout action.
      this.checkoutForm = this.querySelector('.mini-cart__checkout');
      this.checkoutForm.addEventListener('submit', this.handleCheckout);

      // Request a fresh cart to ensure all subcomponents are up to date.
      // If the fetch rejects (e.g. Theme Editor preview session expired and the proxied
      // /checkouts/sim endpoint 403s with an HTML error page), still clear the busy flag
      // so the spinner doesn't sit on forever.
      window.cart.get().catch(() => this.isBusy(false));
    }

    /**
     * Children elements may explicitly set this cart's busy flag in order to prevent
     * siblings from interfering with any pending requests.
     * @param {boolean} busy - Whether the cart is busy or not.
     */
    isBusy(busy) {
      this.setAttribute('aria-busy', busy);
    }

    /**
     * Toggles the visibility of the mini-cart and its fixed background overlay.
     * Has no effect when mini-cart is displayed in a full page layout.
     */
    toggleVisibility() {
      if (this.isFullPage) {
        return;
      }

      this.isVisible = !this.isVisible;
      this.setAttribute('data-is-visible', this.isVisible);
      if (this.isVisible) {
        window.cart
          .get()
          .then((cart) => {
            window.dispatchEvent(
              new CustomEvent('mini-cart-opened', { detail: cart }),
            );
          })
          .catch(() => this.isBusy(false));
      }

      // FB-1429 (81071): let the toggle button mirror the drawer's state in
      // `aria-expanded`. Dispatched on `document` because the toggle lives in
      // the header while the drawer is a direct child of <body>.
      document.dispatchEvent(
        new CustomEvent('mini-cart:visibility', {
          detail: { visible: this.isVisible },
        }),
      );

      if (this.isVisible) {
        // Ensure no scroll behavior does not get out of sync.
        document.body.classList.add('mini-cart-noscroll');
        // Must precede the focus call: focus() is silently dropped on an inert
        // subtree.
        this.setHidden(false);
        // Focus on the mini-cart.
        this.previouslyFocusedElement = document.activeElement;

        // FB-1429 (81069, 81082, 81083): engaging the shared primitive is what
        // applies role="dialog" / aria-modal, moves focus to the close button,
        // contains Tab, marks the rest of <body> inert and binds Escape.
        const focusStore = getFocusStore();
        if (focusStore) {
          focusStore.trapFocus(this, this.dismissButton);
        } else {
          this.dismissButton.focus();
        }
        return;
      }

      // Ensure no scroll behavior does not get out of sync.
      document.body.classList.remove('mini-cart-noscroll');

      // Restore the previously focused element before the mini-cart took over,
      // in most cases it will be `mini-cart-toggle`.
      //
      // Fall back to the toggle when the recorded element is inside the drawer
      // or has since been removed from the page. displayError() re-opens an
      // already-open drawer, which records an element inside it — and now that
      // the closed drawer is inert, restoring focus there would drop focus to
      // <body> instead of leaving it somewhere usable.
      let restoreFocusTo = this.previouslyFocusedElement;
      if (
        !restoreFocusTo ||
        !restoreFocusTo.isConnected ||
        this.contains(restoreFocusTo)
      ) {
        restoreFocusTo = document.querySelector('.mini-cart-toggle__button');
      }
      this.previouslyFocusedElement = null;

      const focusStore = getFocusStore();
      if (focusStore) {
        // Order matters. removeTrapFocus releases the trap — which reverts the
        // dialog semantics and un-inerts the background — and only then moves
        // focus. Restoring focus here directly would run while the header is
        // still inert, and the focus() call would be dropped on the floor.
        focusStore.removeTrapFocus(restoreFocusTo);
      } else if (restoreFocusTo) {
        restoreFocusTo.focus();
      }

      // Last: focus has left the drawer by this point, so nothing is being
      // blurred out from under the user.
      this.setHidden(true);
    }

    /**
     * Take the closed drawer out of the tab order and out of the accessibility
     * tree entirely. No-op for the full-page layout, which is a page rather
     * than an overlay and is always available.
     *
     * `aria-hidden` accompanies `inert` for Safari < 15.5, which does not
     * support inert. Same pattern as the mobile navigation drawer (81224).
     *
     * @param {boolean} hidden - Whether the drawer is currently dismissed.
     */
    setHidden(hidden) {
      if (this.isFullPage) {
        return;
      }

      if (hidden) {
        this.setAttribute('inert', '');
        this.setAttribute('aria-hidden', 'true');
        return;
      }

      this.removeAttribute('inert');
      this.removeAttribute('aria-hidden');
    }

    /**
     * Write one concise sentence to the drawer's live region.
     *
     * FB-1429 (81069): replaces `aria-live="polite" aria-relevant="all"` on the
     * drawer itself, which re-announced large regions of the cart on every
     * line-item mutation.
     *
     * Skipped while the drawer is dismissed — it is `aria-hidden` then, so the
     * announcement would be discarded anyway, and writing to it would only risk
     * a burst of stale messages at the moment it opens.
     *
     * @param {string} message - The message to announce.
     */
    announce(message) {
      if (!this.statusRegion || !message) {
        return;
      }
      if (!this.isVisible) {
        return;
      }
      if (this.statusRegion.textContent === message) {
        return;
      }
      this.statusRegion.textContent = message;
    }

    /**
     * Build the cart summary announcement for the live region.
     * @param {Object} cart - Shopify's cart object.
     * @returns {string} The message, or an empty string if strings are missing.
     */
    statusSummary(cart) {
      const locales = window.locales?.cart;
      if (!locales) {
        return '';
      }

      const itemCount = cart.items
        .filter((item) => !(item.properties && item.properties._is_bundle_item))
        .reduce((sum, item) => sum + item.quantity, 0);

      if (itemCount === 0) {
        return locales.empty || '';
      }

      if (!locales.status_summary) {
        return '';
      }

      // The `cart:get` listener registered above this one has already written
      // the bundle-adjusted total into these spans, so this reads the same
      // figure the user sees rather than recomputing it.
      const subtotal = this.checkoutTotalSpans?.[0]?.innerText || '';

      return locales.status_summary
        .replace('{{ count }}', itemCount)
        .replace(
          '{{ items }}',
          itemCount === 1 ? locales.item_singular : locales.item_plural,
        )
        .replace('{{ subtotal }}', subtotal)
        .trim();
    }

    /**
     * Updates all of the cart's line items with a fresh DOM.
     * @param {Object} cart - Shopify's cart object.
     */
    refreshCartItems(cart) {
      // Remove any previous error messages.
      this.querySelectorAll('.mini-cart__error').forEach((element) =>
        element.remove(),
      );

      // Adding or removing a selling plan results in a new line item, even if everything
      // else is the same, so all line item elements must be recreated.
      const previousLineItems = this.querySelectorAll('cart-line-item');
      previousLineItems.forEach((item) => item.remove());

      cart.items
        .filter((item) => {
          if (item.properties && item.properties.Gift) {
            // Gifts are not displayed with regular line items.
            return false;
          }
          if (item.properties && item.properties._is_bundle_item) {
            // A bundle's children items are not displayed directly.
            return false;
          }
          return true;
        })
        .forEach((incomingItem) => {
          const cartLineItem = document.createElement('cart-line-item');
          this.lineItemSection.append(cartLineItem);
          cartLineItem.initialize(incomingItem, this);
        });
    }

    /**
     * Triggers the cart to open and displays an error message to the user.
     * @param {string} message - The message to display.
     */
    displayError(message) {
      if (!this.isFullPage) {
        // Always set this cart to be visible for each message to display.
        this.isVisible = false;
        this.toggleVisibility();
      }

      // Ensure the error message is in view.
      if (this.isFullPage) {
        this.scrollIntoView(true);
      } else {
        this.scrollTo({ top: 0 });
      }

      // Do not display a duplicate message.
      const errorMessages = this.querySelectorAll('.mini-cart__error__message');
      const duplicateMessage = [...errorMessages].filter((element) =>
        element.textContent.includes(message),
      );
      if (duplicateMessage.length) {
        return;
      }

      this.lineItemSection.insertAdjacentHTML(
        'beforebegin',
        `
      <div class="mini-cart__error">
        <div class="mini-cart__error__message">
          ${message}
        </div>
      </div>
    `,
      );
    }

    /**
     * If the cart contains a bundle by Bundle Builder then a different checkout destination
     * must be configured before posting.
     * @param {Event} event
     */
    handleCheckout(event) {
      if (!window.cart.hasBundleByApp()) {
        // Normal checkout.
        event.target.setAttribute('action', '/checkout');
        return;
      }
      // The app's bundle must be the last item in the cart to prevent quantity issues with other items.
      // This cart data can be manipulated directly, it does not need to sync with Shopify.
      const cartInput = event.target.querySelector('input[name="_cart"]');
      if (!cartInput) {
        return;
      }
      // Make a deep clone.
      const cartData = JSON.parse(JSON.stringify(window.cart.data));
      const bundleItem = cartData.items.find(
        (item) => item.properties && item.properties._bundle_id > 0,
      );
      const bundleItemIndex = cartData.items.indexOf(bundleItem);
      // Move this bundle to the end of the items array.
      cartData.items.push(cartData.items.splice(bundleItemIndex, 1)[0]);
      cartInput.value = JSON.stringify(cartData);
      // Update the form's action to the app.
      event.target.setAttribute('action', '/apps/bundles/cart');
    }

    /**
     * Updates the cart's empty state, based on the cart's `item_count` property.
     * @param {Object} cart - Shopify cart object.
     */
    updateEmptyState(cart) {
      if (cart.item_count === 0) {
        this.setAttribute('data-empty', 'true');
        if (this.suggestedProductPicker) {
          // This component is automatically opened when the cart is empty.
          this.suggestedProductPicker.querySelector('details').open = true;
        }
        return;
      }
      this.setAttribute('data-empty', 'false');
    }
  }
  customElements.define('mini-cart', MiniCart);
})();
